import React, { PureComponent } from 'react'
import styled from 'styled-components';
import CupoyRouter from "components/commons/router/CupoyRouter";
// import PaginationView from 'components/commons/pagination/PaginationView';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import actionCreators from 'actions/creators';
import { Colors, GlobalStyle } from 'stylecomponents';
import PointcardListItem from 'components/pointcard/commons/PointcardListItem';
import CupoyGridRepeat from 'components/commons/CupoyGridRepeat';
import NewProductsSideBarView from 'components/newproducts/commons/NewProductsSideBarView';
import productUtil, { PRODUCT_COVER_SIZE } from 'util/productUtil';

const Container = GlobalStyle.SubContainer.extend`
  display: grid;
  grid-template-columns: 1fr 244px;
  grid-template-rows: auto auto;
  grid-gap: ${GlobalStyle.ViewSpace}px;
  margin-top: ${props => props.marginTop? GlobalStyle.ViewSpace:0}px;
`

const Main = styled.div`
`

const FlexContainer = styled.div`
  position: relative;
  /* display: flex; */
  /* flex-direction: row; */
  /* flex-wrap: wrap; */
  margin-bottom: ${GlobalStyle.ViewSpace}px;
`

const Footer = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
`

const Header = styled.ul`
  padding: 10px 25px 20px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin: 0 0 ${GlobalStyle.ViewSpace}px;
  background-color: #FFF;
  border-radius: 5px;
  border: 1px solid #D9D9D9;
`;

const HeaderItem = styled.li`
  margin-top: 10px;
  color: ${({ isActive }) => isActive ? Colors.MAIN_COLOR : Colors.Dark3};
  font-size: 14px;
  cursor: pointer;

  &:not(:last-child) {
    margin-right: 15px;
  }
`;

const HeaderLoading = styled.div`
  margin: 10px auto 0;
`;

const HeaderError = styled.div`
  margin: 10px auto 0;
`;
const HeaderErrorTitle = GlobalStyle.ErrorContainerTitle.extend`
    margin: 0;
`;


class PointcardView extends PureComponent {
  constructor(props) {
    super(props);

    this.switchGroup = this.switchGroup.bind(this);
    this.listCardProducts = this.listCardProducts.bind(this);

    this.state = {
      currentGroupid: 0,
      productIds: 'all',
      isEmpty: false,
      isLoading: false,
      isError: false,
      isNoMore: false,
      productLen: 16,
    };
  }

  componentDidMount() {
    window.scrollTo({ top: 0 });

    this.props.cardActions.getProductGroups().then(({ grpids = [] } = {}) => {
      this.switchGroup(grpids[0]);
    });
  }

  switchGroup(groupid){

    if(
      (groupid === this.state.currentGroupid) || 
      this.state.isLoading
    ) {
      return;
    }

    this.setState({
      sidebar: true,
      currentGroupid: groupid,
      isEmpty: false,
      isError: false,
      isNoMore: false,
    }, () => {
      this.listCardProducts();
    })
  }

  listCardProducts() {

    const {
      currentGroupid,
      // isLoading,
      isEmpty,
      isError,
      isNoMore,
      productLen,
    } = this.state;

    if(this.props.isloading || isEmpty || isError || isNoMore)
      return;

    const {
      cardProductIdsByGroupId,
    } = this.props;

    let cardProductIds = cardProductIdsByGroupId[currentGroupid];

    let start = 0;

    if(Array.isArray(cardProductIds)) {
      start = cardProductIds.length;
    }

    this.setState({
      isLoading: true,
      isEmpty: false,
    }, () => {
      this.props.cardActions.listCardProducts({
        start: start,
        len: productLen,
        productgrpid: currentGroupid
      }).then(({ resultSize = 0 } = {}) => {
        
        const {
          currentGroupid,
        } = this.state;

        const {
          cardProductIdsByGroupId,
        } = this.props;

        let productList = cardProductIdsByGroupId[currentGroupid] || [];

        this.setState({
          isLoading: false,
          isEmpty: productList.length === 0,
          isNoMore: (productList.length > 0) && (resultSize < productLen),
        });
      }, () => {
        this.setState({
          isLoading: false,
          isError: true,
        });
      });
    })
  }

  addCart = (productid, routeToCart = false, event) => {
    event.stopPropagation();
    this.props.webActions.openAddProductDialog({ productid, routeToCart });
  }

  routeToContent = id => {
    this.props.webActions.cupoyStateGo(CupoyRouter.STATES.POINTCARD_PRODUCT, { id });
  }

  cellRenderer = ({
    key,
    index,
    columnIndex,
    rowIndex,
    isScrolling,
    isVisible,
    style,
    parent,
    measure,
    updateRowSize,
    measureCache
  }) => {

    const { currentGroupid } = this.state;
    
    const {
      cardProductIdsByGroupId,
      cardProductMap,
    } = this.props;

    const productList = cardProductIdsByGroupId[currentGroupid];
    const productId = productList[index];
    const cardProduct = cardProductMap[productId];

    const {
      productid,
      thumbimg,
      productname = '',
      hottag = false,
      memberprice,
      createtime,
      updatetime,
    } = cardProduct;

    const t = createtime || updatetime;
    const imageSrc = productUtil.getProductCover(PRODUCT_COVER_SIZE.LARGE, productid, thumbimg, t);

    return (
      <PointcardListItem
        style={style}
        key={productId}
        productId={productid}
        name={productname.trim()}
        needMarginRight={(index + 1) % 4 !== 0}
        imageSrc={imageSrc}
        isHot={hottag}
        price={memberprice}
        addCart={this.addCart}
        routeToContent={this.routeToContent}
      />
    );
  }

  render() {

    const {
      currentGroupid,
    } = this.state;

    const {
      cardProductIdsByGroupId,
      productGroups,
      groupIsloading,
      groupError,
    } = this.props;

    let productList = cardProductIdsByGroupId[currentGroupid] || [];

    return (
      <Container>
        <Main>
          <Header>
            {productGroups.map(group => {

            const { grpid, grpname = '' } = group;

            return (
                <HeaderItem 
                  key={grpid}
                  onClick={() => this.switchGroup(grpid)}
                  isActive={grpid === currentGroupid}
                >
                  {grpname.trim()}
                </HeaderItem>
              )
            })}
            {groupIsloading ?
                <HeaderLoading>
                    <GlobalStyle.Spin />
                </HeaderLoading>
                :null
            } 
            {groupError ?
                <HeaderError>
                    <HeaderErrorTitle>
                      無法取得列表，請重新整理後再嘗試。
                    </HeaderErrorTitle>
                </HeaderError>
                :null
            }
          </Header>
          <FlexContainer>
            {
              !this.state.isEmpty && !this.state.isError &&
              (
                  <CupoyGridRepeat
                    listId={this.constructor.name}
                    cellRenderer={this.cellRenderer}
                    loadMoreRows={this.listCardProducts}
                    items={productList}
                    restoreWindowScroll={true}
                    useWindowScroll={true}
                    columnCount={4}
                    isLoading={this.props.isloading}
                  />
              )
            }
            {this.props.isloading ?
              <GlobalStyle.LoadingContainer>
                <GlobalStyle.Spin />
              </GlobalStyle.LoadingContainer>
              :
              null
            }   
            {this.props.error ?
              <GlobalStyle.BasicBlock>
                <GlobalStyle.ErrorContainer>
                  <GlobalStyle.ErrorContainerTitle>
                    發生錯誤
                  </GlobalStyle.ErrorContainerTitle>
                  <GlobalStyle.ErrorContainerDesription>
                    無法取得熱門商品列表，請重新整理後再嘗試。
                  </GlobalStyle.ErrorContainerDesription>
                </GlobalStyle.ErrorContainer>
              </GlobalStyle.BasicBlock>
                :
                null
            }
            {this.state.isEmpty ? 
              <GlobalStyle.BasicBlock>
                <GlobalStyle.ErrorContainer>
                  <GlobalStyle.ErrorContainerTitle>
                    查無資料
                  </GlobalStyle.ErrorContainerTitle>
                  <GlobalStyle.ErrorContainerDesription>
                    目前此類查無商品
                  </GlobalStyle.ErrorContainerDesription>
                </GlobalStyle.ErrorContainer>
              </GlobalStyle.BasicBlock>
              :
              null
            }
          </FlexContainer>
          <Footer>
            {/* <PaginationView /> */}
          </Footer>
        </Main>
        <NewProductsSideBarView />
      </Container>
    )
  }
}

/*--------------------------
    Reducer Props
--------------------------*/
const mapStateToProps = function(state) {
  return {
    cardProductIdsByGroupId: state.card.cardProductIdsByGroupId,
    productGroups: state.card.productGroups,
    cardProductMap: state.card.cardProductMap,
    groupIsloading: state.card.groupIsloading,
    groupError: state.card.groupError,
    isloading: state.card.isloading,
    error: state.card.error,
    haslogin: state.member.haslogin,
  };
};

/*--------------------------
  Reducer Action
--------------------------*/
const mapActionToProps = function(dispatch) {
  return {
    cardActions: bindActionCreators(
      actionCreators.cardActionCreators,
      dispatch,
    ),
    webActions: bindActionCreators(
      actionCreators.webActionCreators,
      dispatch,
    ),
    cardCartActions: bindActionCreators(
      actionCreators.cardCartActionCreators,
      dispatch,
    ),
  };
};

/*--------------------------
  export
--------------------------*/
export default connect(mapStateToProps, mapActionToProps, null, {
  forwardRef: true
})(PointcardView);
